import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js'
import { FeatureFlags } from './constants/constants.ts'
import { initSentry } from './lib/sentry'

// Initialize Sentry
initSentry()

// Initialize PostHog
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'phc_placeholder'

createRoot(document.getElementById("root")!).render(
  <PostHogProvider
    apiKey={posthogKey}
    options={{
      api_host: "https://us.i.posthog.com",
      disable_surveys:true
    }}
  >
    <App />
  </PostHogProvider>
);
